import FloorMapContainer from "components/floorMap/FloorMapContainer";

export default function FloorMapPage() {
  return <FloorMapContainer />;
}
